import { http } from '../../utils/http';

// 后端统一回传调用接口
export const uploadAdvertise = (data: Object) =>
  http.post('/tmcthirdadwordsdeliveryservice_uploadclueconvertdata', data);
